// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"f228351e","367":"2b1f000b"}[chunkId] + ".chunk.js";
};